<template>
  <b-modal
      :id="`modal-binnacle-${actualId}`"
      :ref="`modal-binnacle`"
      :title="title"
      no-close-on-backdrop
      size="md"
      hide-footer
  >
    <BinnacleList
        :id="`list-binnacle-${actualId}`"
        ref="list-binnacle"
    />
  </b-modal>
</template>
<script>

import BinnacleList from './BinnacleList';

export default {
  name: 'ModalBinnacle',
  props: ['title'],
  components: {
    BinnacleList
  },
  data() {
    return {
      actualId: ''
    };
  },
  methods: {
    show(id) {
      this.actualId = id;
      this.$refs['modal-binnacle'].show();
      setTimeout(() => {
        this.$refs['list-binnacle'].list(this.actualId);
      }, 500);
    },
  }
};
</script>
